import { render, staticRenderFns } from "./view.html?vue&type=template&id=62274d4a&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./mobile.less?vue&type=style&index=0&id=62274d4a&lang=less&scoped=true&"
import style1 from "./rollDetail.less?vue&type=style&index=1&id=62274d4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62274d4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62274d4a')) {
      api.createRecord('62274d4a', component.options)
    } else {
      api.reload('62274d4a', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=62274d4a&scoped=true&", function () {
      api.rerender('62274d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rollDetail/rollDetail.vue"
export default component.exports